<template>
  <div class="toolbar">
    <div class="wrap">
      <div class="tools">
        <div class="status">
          {{info}}
        </div>
        <div class="controls">
          <div 
            v-if="toggle_preview != null" 
            class="light-text" 
            v-on:click="toggle_preview()">
            {{this.preview ? "Hide Preview" : "Show Preview"}}
          </div>
          <button 
            class="large red" 
            v-if="secondary_action != null" 
            v-bind:class="{loading: this.loading}"
            v-on:click="secondary_action()">
            {{secondary_action_text || "Cancel"}}
          </button>
          <button 
            class="large blue" 
            v-if="primary_action != null" 
            v-bind:class="{loading: this.loading}"
            v-on:click="primary_action()">
            {{primary_action_text || "Save"}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: [
    'loading', 
    'primary_action',
    'primary_action_text',
    'secondary_action',
    'secondary_action_text',
    'toggle_preview',
    'preview',
    'info'
  ],
  data: () => {
    return {}
  },
}
</script>